<template>
    <div class="not-found">
        <h1>{{ $t("App.NotFound.Header") }}</h1>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"

    @Component
    export default class NotFound extends Vue {
    }
</script>

<style scoped>
    .not-found {
        margin: 20px;
    }
</style>
